import { render, staticRenderFns } from "./ClientesForm.vue?vue&type=template&id=768ed2d3"
import script from "./ClientesForm.vue?vue&type=script&lang=js"
export * from "./ClientesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports